/**
 * @generated SignedSource<<40e7fa84e717b8ab907360319830de5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ThumbnailKind = "UPLOAD" | "URL" | "%future added value";
export type ThumbnailInput = {
  kind: ThumbnailKind;
  value: string;
};
export type ThumbnailOption_setThumbnailMutation$variables = {
  nodeId: string;
  thumbnail?: ThumbnailInput | null;
};
export type ThumbnailOption_setThumbnailMutation$data = {
  readonly setThumbnail: {
    readonly node: {
      readonly __typename?: string;
      readonly canUpdateThumbnail?: {
        readonly value: boolean;
      };
      readonly thumbnail?: {
        readonly url: URIString;
      } | null;
    };
  } | null;
};
export type ThumbnailOption_setThumbnailMutation = {
  response: ThumbnailOption_setThumbnailMutation$data;
  variables: ThumbnailOption_setThumbnailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "thumbnail"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "nodeId",
        "variableName": "nodeId"
      },
      {
        "kind": "Variable",
        "name": "thumbnail",
        "variableName": "thumbnail"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "canUpdateThumbnail",
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canRename",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Folder",
  "abstractKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "canUpdateThumbnail",
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canUpdate",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Vault",
  "abstractKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Thumbnail",
  "kind": "LinkedField",
  "name": "thumbnail",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ThumbnailOption_setThumbnailMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ResolversSetThumbnailMutationPayload",
        "kind": "LinkedField",
        "name": "setThumbnail",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "type": "HasThumbnailInterface",
                "abstractKey": "__isHasThumbnailInterface"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ThumbnailOption_setThumbnailMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ResolversSetThumbnailMutationPayload",
        "kind": "LinkedField",
        "name": "setThumbnail",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/)
                ],
                "type": "HasThumbnailInterface",
                "abstractKey": "__isHasThumbnailInterface"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "901c240480c1ea650715286b03b85c29",
    "id": null,
    "metadata": {},
    "name": "ThumbnailOption_setThumbnailMutation",
    "operationKind": "mutation",
    "text": "mutation ThumbnailOption_setThumbnailMutation(\n  $nodeId: ID!\n  $thumbnail: ThumbnailInput\n) {\n  setThumbnail(input: {nodeId: $nodeId, thumbnail: $thumbnail}) {\n    node {\n      __typename\n      ... on Folder {\n        canUpdateThumbnail: canRename {\n          value\n        }\n      }\n      ... on Vault {\n        canUpdateThumbnail: canUpdate {\n          value\n        }\n      }\n      ... on HasThumbnailInterface {\n        __isHasThumbnailInterface: __typename\n        __typename\n        thumbnail {\n          url\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5f89e6f5eb16254a9dffb0553d49e5b6";

export default node;
